import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";

function Aboutappkinekt() {
  return (
    <section className="about-app-kinekt p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="about-app-box">
              <h2 className="head-h2-kinekt">
                About the <span style={{ color: "#20A2BE" }}>App</span>
              </h2>
              <p>
                Kinekt is a healthcare-focused platform designed to help care
                providers collect and analyze patient feedback from multiple
                sources, improving service quality and response times.
              </p>
              <h4>Project Details</h4>
              <ul>
                <li>
                  <span style={{ color: "#314252", fontWeight: "700" }}>
                    Industry
                  </span>
                  : Healthcare – Focused on enhancing patient care and
                  operational efficiency through technology.
                </li>
                <li>
                  <span style={{ color: "#314252", fontWeight: "700" }}>
                    Business Type
                  </span>
                  : Enterprise – A large-scale organization with complex digital
                  transformation needs.
                </li>
                <li>
                  <span style={{ color: "#314252", fontWeight: "700" }}>
                    Client’s Goal
                  </span>
                  : Improve patient feedback collection and integrate AI-powered
                  analytics.
                </li>
                <li>
                  <span style={{ color: "#314252", fontWeight: "700" }}>
                    Services Provided
                  </span>
                  : AI Integration, UI/UX Revamp, Web & Mobile App Development
                </li>
              </ul>
              <Link
                style={{
                  background: "#20A2BE",
                  color: "#fff",
                  border: "1px solid #20A2BE",
                }}
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Book Your Complimentary Consultation
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="offset-xl-1">
            {/* <Swiper
              loop={true}
              autoplay={{
                delay: 4000,
                disableOnInteraction: false,
              }}
              spaceBetween={10}
              modules={[Autoplay, Pagination]}
              pagination={{ clickable: true }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 1,
                },
                1024: {
                  slidesPerView: 1,
                },
                1366: {
                  slidesPerView: 1,
                },
                1600: {
                  slidesPerView: 1,
                },
              }}
              className="kinekt-about"
            >
              <SwiperSlide>
                <div className="about-mob-slide d-none d-md-block">
                  <StaticImage
                    src="../../../images/case-studies/kinekt-new/about-app.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={515}
                    height={703}
                  />
                </div>
                <div className="about-mob-slide d-block d-md-none text-center">
                  <StaticImage
                    src="../../../images/case-studies/kinekt-new/about-app-mob-view.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={348}
                    height={696}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="about-mob-slide d-none d-md-block">
                  <StaticImage
                    src="../../../images/case-studies/kinekt-new/about-app.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={515}
                    height={703}
                  />
                </div>
                <div className="about-mob-slide d-block d-md-none text-center">
                  <StaticImage
                    src="../../../images/case-studies/kinekt-new/about-app-mob-view.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={348}
                    height={696}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="about-mob-slide d-none d-md-block">
                  <StaticImage
                    src="../../../images/case-studies/kinekt-new/about-app.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={515}
                    height={703}
                  />
                </div>
                <div className="about-mob-slide d-block d-md-none text-center">
                  <StaticImage
                    src="../../../images/case-studies/kinekt-new/about-app-mob-view.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={348}
                    height={696}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="about-mob-slide d-none d-md-block">
                  <StaticImage
                    src="../../../images/case-studies/kinekt-new/about-app.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={515}
                    height={703}
                  />
                </div>
                <div className="about-mob-slide d-block d-md-none text-center">
                  <StaticImage
                    src="../../../images/case-studies/kinekt-new/about-app-mob-view.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={348}
                    height={696}
                  />
                </div>
              </SwiperSlide>
            </Swiper> */}
            <div className="about-mob-slide d-none d-md-block">
              <StaticImage
                src="../../../images/case-studies/kinekt-new/about-app.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={515}
                height={703}
              />
            </div>
            <div className="about-mob-slide d-block d-md-none text-center">
              <StaticImage
                src="../../../images/case-studies/kinekt-new/about-app-mob-view.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={348}
                height={696}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Aboutappkinekt;
